var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          attrs: {
            "data-vv-scope": "custom-document-part-1",
            autocomplete: "off"
          },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("h2", { staticClass: "mb-10" }, [
            _vm._v("Formulario de Solicitud de Presupuesto " + _vm._s(_vm.anio))
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Programa *" } },
                  [
                    _c(
                      "v-select",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        class: {
                          "v-select-danger": _vm.errors.has(
                            "custom-document-part-1.program"
                          )
                        },
                        attrs: {
                          "data-cy": "program",
                          "data-vv-as": "programa",
                          name: "program",
                          options: _vm.optionsProgram
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "spinner",
                            fn: function() {
                              return [
                                _vm.loadingProgram
                                  ? _c("b-spinner", {
                                      style: {
                                        opacity: _vm.loadingProgram ? 1 : 0
                                      },
                                      attrs: { small: "", variant: "primary" }
                                    })
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.formData.program,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "program", $$v)
                          },
                          expression: "formData.program"
                        }
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            " no hay programa para el criterio de búsqueda "
                          )
                        ])
                      ],
                      2
                    ),
                    _vm.errors.has("custom-document-part-1.program")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document-part-1.program"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
          ])
        ]
      ),
      _c("form", { attrs: { "data-vv-scope": "custom-document-part-2" } }, [
        _c("div", { staticClass: "row my-3" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-md-12 mt-3" },
            [
              _c("add-budget-concept", {
                on: { "add-budget-concept": _vm.addBudgetConcept }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12 mt-3" },
            [
              _c("table-budget-concept", {
                attrs: {
                  "budget-concepts": _vm.formData.budgetConcepts,
                  multiple: ""
                },
                model: {
                  value: _vm.formData.budgetConceptsSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "budgetConceptsSelected", $$v)
                  },
                  expression: "formData.budgetConceptsSelected"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
        ])
      ]),
      _c("form", { attrs: { "data-vv-scope": "custom-document-part-3" } }, [
        _c("div", { staticClass: "row my-3" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Para el financiamiento de: *" } },
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document-part-3.financing")
                        ? false
                        : null,
                      "data-vv-as": "financiamiento",
                      "data-cy": "financing",
                      name: "financing",
                      type: "text",
                      rows: "3",
                      maxLength: "1000"
                    },
                    model: {
                      value: _vm.formData.financing,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "financing", $$v)
                      },
                      expression: "formData.financing"
                    }
                  }),
                  _c("div", { staticClass: "row justify-content-between" }, [
                    _c("div", { staticClass: "col-md-6 text-left" }, [
                      _vm.errors.has("custom-document-part-3.financing")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document-part-3.financing"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "col-md-6 text-right" }, [
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Contador de caracteres",
                              expression: "'Contador de caracteres'"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formData.financing.length) +
                              "/1000 "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "O.C o N° Factura" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      "data-vv-as": "o.c o nº factura",
                      "data-cy": "number",
                      name: "number",
                      type: "text",
                      maxLength: "15"
                    },
                    model: {
                      value: _vm.formData.number,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "number", $$v)
                      },
                      expression: "formData.number"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "BIP" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      "data-cy": "bip",
                      name: "bip",
                      type: "number",
                      formatter: _vm.maxLengthNumber
                    },
                    model: {
                      value: _vm.formData.bip,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "bip", $$v)
                      },
                      expression: "formData.bip"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Resolución" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      "data-cy": "resolution",
                      name: "resolution",
                      type: "number",
                      formatter: _vm.maxLengthNumber
                    },
                    model: {
                      value: _vm.formData.resolution,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "resolution", $$v)
                      },
                      expression: "formData.resolution"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
        ]),
        _c(
          "div",
          { staticClass: "row align-items-center mt-5" },
          [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "col-md-3 align-items-end" },
              [
                _c("UploadFile", {
                  attrs: {
                    permission: "*",
                    accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                    text: "Seleccionar documentos",
                    "upload-to": "ed",
                    "button-class": {
                      "btn-block": true,
                      "mb-5": _vm.errors.has("custom-document.fileName")
                    },
                    "container-class": "w-100"
                  },
                  on: {
                    input: function($event) {
                      return _vm.addFile()
                    }
                  },
                  model: {
                    value: _vm.file,
                    callback: function($$v) {
                      _vm.file = $$v
                    },
                    expression: "file"
                  }
                })
              ],
              1
            ),
            _c("br"),
            _c(
              "div",
              { staticClass: "col-md-3 align-items-end" },
              [
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "has-permission",
                        rawName: "v-has-permission",
                        value: "ED060",
                        expression: "'ED060'"
                      },
                      {
                        name: "b-modal",
                        rawName: "v-b-modal",
                        value: "add-file-repository",
                        expression: "'add-file-repository'"
                      }
                    ],
                    staticClass: "btn-icon mt-1",
                    attrs: {
                      variant: "secondary",
                      "data-cy": "from-repository"
                    }
                  },
                  [
                    _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                    _vm._v(" Desde el repositorio ")
                  ],
                  1
                )
              ],
              1
            ),
            _vm._l(_vm.formData.files, function(file) {
              return _c("div", { key: file.id, staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center" },
                  [
                    _c("vs-icon", {
                      attrs: {
                        icon: "description",
                        size: "45px",
                        color: "primary"
                      }
                    }),
                    _c(
                      "b",
                      { staticClass: "text-truncate w-100 text-center" },
                      [_vm._v(_vm._s(file.name))]
                    ),
                    _c("vs-button", {
                      attrs: { color: "danger", type: "flat", icon: "clear" },
                      on: {
                        click: function($event) {
                          return _vm.removeFile(file.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            }),
            _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1)
          ],
          2
        ),
        _c("div", { staticClass: "row mt-3 form-group" }, [
          _c(
            "label",
            {
              staticClass: "col-3 col-form-label",
              attrs: { for: "requestedBy" }
            },
            [_vm._v("Solicitado por:")]
          ),
          _c(
            "div",
            { staticClass: "col-3" },
            [
              _c("v-select", {
                staticClass: "w-100",
                attrs: {
                  "data-cy": "type-requested",
                  options: _vm.optionsTypeRequested,
                  reduce: function(option) {
                    return option.value
                  },
                  cleareable: false
                },
                model: {
                  value: _vm.typeRequested,
                  callback: function($$v) {
                    _vm.typeRequested = $$v
                  },
                  expression: "typeRequested"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _vm.typeRequested === "user"
                ? _c("list-user", {
                    ref: "requested",
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "",
                      "data-cy": "requested-user",
                      "data-vv-as": "usuario",
                      name: "requested",
                      label: "",
                      placeholder: "Selecciona un usuario"
                    },
                    model: {
                      value: _vm.formData.requested,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "requested", $$v)
                      },
                      expression: "formData.requested"
                    }
                  })
                : _vm._e(),
              _vm.typeRequested === "group"
                ? _c("list-groups", {
                    ref: "requested",
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "",
                      label: "",
                      placeholder: "Selecciona un grupo",
                      "data-cy": "requested-group",
                      "data-vv-as": "grupo",
                      name: "requested",
                      typeList: 1
                    },
                    model: {
                      value: _vm.formData.requested,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "requested", $$v)
                      },
                      expression: "formData.requested"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      !!_vm.error.message
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-right"
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.error.message) + " ")
              ])
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "cancel",
                color: "primary",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v(" Cancelar ")]
          ),
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "save",
                color: "success",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [
              _vm._v(" Crear "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.saving,
                    expression: "saving"
                  }
                ],
                staticClass: "spinner-border spinner-border-sm text-primary"
              })
            ]
          )
        ],
        1
      ),
      _c("repository-selector", {
        attrs: {
          "modal-id": "add-file-repository",
          "add-file": _vm.addFileRepo,
          files: _vm.formData.attachments,
          "remove-file": _vm.removeFile
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", [_vm._v("Conceptos Presupuestarios *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntar Solicitud de compra Autorizada por DAF")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }